import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined'
import CodeIcon from '@mui/icons-material/Code'
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined'
import { PERMISSIONS } from 'common/utils/HabilitationUtil'

const HABILITATION = {
    SUPERVISION: 'supervision',
    ADMIN: 'admin',
    GDL: 'gdl',
    DEVELOPER: 'developer',
    SUPPORT: 'support',
}

const HABILITATIONS = [
    { key: HABILITATION.ADMIN, label: 'Admin', Icon: AdminPanelSettingsOutlinedIcon },
    { key: HABILITATION.DEVELOPER, label: 'Developpeur', Icon: CodeIcon },
    { key: HABILITATION.SUPERVISION, label: 'Supervision', Icon: MonitorHeartOutlinedIcon },
    { key: HABILITATION.SUPPORT, label: 'Support', Icon: SupportAgentIcon },
    { key: HABILITATION.GDL, label: 'Licences', Icon: VpnKeyOutlinedIcon },
]

const RESOURCE_LABELS = {
    users: 'Utilisateurs',
    instances: 'Instances',
    services: 'Services',
    timeErrors: 'Time Errors',
    statisticsSupervision: 'Statistiques supervision',
    dashboardSupport: 'Tableau de bord Support',
    issue: 'Création de tickets',
    statistics: 'Statistiques support',
    tickets: 'Mes tickets',
    devs: 'Suivi des lots',
    recette: 'Recette',
    roadmap: 'Roadmap',
    versions: 'Versions',
    customers: 'Clients',
    settingLicenses: 'Paramétrage licences',
    commercial: 'Commerce',
    license: 'Licences',
}

const ACTION_LABELS = [
    { key: 'view', label: 'Consulter' },
    { key: 'create', label: 'Créer' },
    { key: 'update', label: 'Modifier' },
    { key: 'delete', label: 'Supprimer' },
]

const getAccessLabel = (rights) => {
    const actions = ACTION_LABELS.filter(({ key }) => rights[key])
    if (actions.length === ACTION_LABELS.length) return 'Accès complet'
    if (actions.length === 1 && rights.view) return 'Consultation'
    return actions.map(({ label }) => label).join(', ')
}

const CATEGORIES = [
    { label: 'Supervision', resources: ['instances', 'services', 'timeErrors', 'statisticsSupervision', 'versions'] },
    { label: 'Support', resources: ['dashboardSupport', 'issue', 'statistics'] },
    { label: 'Développement', resources: ['tickets', 'devs', 'recette', 'roadmap'] },
    { label: 'Gestion des licences', resources: ['customers', 'settingLicenses', 'commercial', 'license'] },
    { label: 'Administration', resources: ['users'] },
]

const getHabAccess = (hab) => {
    const permissions = PERMISSIONS[hab] ?? {}
    return CATEGORIES
        .map(({ label, resources }) => ({
            category: label,
            items: resources
                .filter(resource => resource in permissions)
                .map(resource => ({
                    resource,
                    label: RESOURCE_LABELS[resource],
                    access: getAccessLabel(permissions[resource]),
                })),
        }))
        .filter(({ items }) => items.length > 0)
}

export { HABILITATION, HABILITATIONS, getHabAccess }
